import React from 'react';
import {
  CadenceScheduleEditor,
  type CadenceData,
} from '@/components/roros/cadence';

/**
 * Step 5 of the Launchpad wizard — delegates to the shared
 * CadenceScheduleEditor. B24 extracted the UI so the settings page can
 * reuse the exact same component; this step is now a thin wrapper that
 * preserves the original prop contract for the wizard.
 */

interface StepCadenceProps {
  value: CadenceData;
  onChange: (data: CadenceData) => void;
  operatingMode: string;
  /** Locale selected in previous step — used to derive time format for TimeInput */
  locale?: string;
}

export function StepCadence({ value, onChange, operatingMode, locale }: StepCadenceProps) {
  return (
    <CadenceScheduleEditor
      value={value}
      onChange={onChange}
      operatingMode={operatingMode}
      locale={locale}
      // Onboarding defaults — all edits allowed, heading visible.
      planningCycleEditable={true}
      timeEditable={true}
      showHeading={true}
    />
  );
}
